import { type AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import { ActionKeys } from '~/actions/constants';
import * as featureTestsActions from '~/actions/feature-tests.actions';
import * as featureTestService from '~/services/feature-tests.service';
import {
  featureTestUserVariantFromJSON,
  type JSONFeatureTestUserVariant,
} from '~/types/FeatureTest';

function* fetchFeatureTests() {
  try {
    const response: AxiosResponse<{ results: JSONFeatureTestUserVariant[] }> = yield call(
      featureTestService.fetchFeatureTests,
    );
    yield put(
      featureTestsActions.fetchFeatureTestSuccess(
        response.data.results.map(featureTestUserVariantFromJSON),
      ),
    );
  } catch (err) {
    // Continue with error.
  }
}

function* postFeatureTestFetchSuccessHook() {
  yield put(featureTestsActions.initializeFeatureTestVariantNames());
}

export default [
  takeLatest(ActionKeys.FETCH_AB_TEST_FEATURES, fetchFeatureTests),
  takeLatest(ActionKeys.FETCH_AB_TEST_FEATURES_SUCCESS, postFeatureTestFetchSuccessHook),
];
